export default __webpack_public_path__ + "static/media/img5.ab4684ad.jpg";